import { useState, useEffect } from 'react';
const pending = { pending: true, fulfilled: null, rejected: null };
export function usePromised(promise) {
    const [state, setState] = useState(pending);
    useEffect(() => {
        let unmounted = false;
        if (!state.pending)
            setState(pending);
        promise.then(value => !unmounted && setState({ pending: null, fulfilled: true, rejected: null, value }), reason => !unmounted && setState({ pending: null, fulfilled: null, rejected: true, reason }));
        return () => {
            unmounted = true;
        };
    }, [promise]);
    return state;
}
//# sourceMappingURL=use-promised.js.map